// Test IDs for the Lutfiye Horeca landing page
export const HORECA = {
  // Header / nav
  nav: 'horeca-nav',
  navLogo: 'horeca-nav-logo',
  navLinkAbout: 'nav-link-about',
  navLinkAdvantages: 'nav-link-advantages',
  navLinkProducts: 'nav-link-products',
  navLinkSanver: 'nav-link-sanver',
  navLinkProcess: 'nav-link-process',
  navLinkFaq: 'nav-link-faq',
  navLinkContact: 'nav-link-contact',
  navLinkPriceList: 'nav-link-price-list',
  navLinkCatalog: 'nav-link-catalog',
  navCtaBtn: 'nav-cta-btn',

  // Hero
  hero: 'hero-section',
  heroCtaPrimary: 'hero-cta-primary',
  heroCtaSecondary: 'hero-cta-secondary',

  // Sections
  valuePropsSection: 'value-props-section',
  storySection: 'story-section',
  categoriesSection: 'categories-section',
  categoryCard: (slug) => `category-card-${slug}`,
  sanverSection: 'sanver-section',
  sanverCard: (slug) => `sanver-card-${slug}`,
  processSection: 'process-section',
  faqSection: 'faq-section',
  certificatesSection: 'certificates-section',
  certificateCard: (slug) => `certificate-card-${slug}`,
  contactSection: 'contact-section',

  // Form fields
  form: 'horeca-lead-form',
  fieldCompanyName: 'field-company-name',
  fieldContactPerson: 'field-contact-person',
  fieldPhone: 'field-phone',
  fieldEmail: 'field-email',
  fieldCompanyType: 'field-company-type',
  fieldCity: 'field-city',
  fieldMonthlyNeed: 'field-monthly-need',
  fieldMessage: 'field-message',
  productCheckbox: (slug) => `product-checkbox-${slug}`,
  submitBtn: 'form-submit-btn',
  formSuccess: 'form-success-message',
  formError: 'form-error-message',

  // Footer
  footer: 'footer-section',

  // Admin panel
  adminTabLeads: 'admin-tab-leads',
  adminTabContent: 'admin-tab-content',
  adminAddCategory: 'admin-add-category',
  adminAddSubcategory: (cid) => `admin-add-subcategory-${cid}`,
  categoryModal: 'category-modal',
  categoryModalClose: 'category-modal-close',
};
